export type OnlineStatus = 'online' | 'offline' | 'idle' | 'dnd';

export interface DiscordRole {
    id: string;
    position: number;
    name: string;
    category: string;
    color: string;
}

export interface DiscordMember {
    id: string;
    username: string;
    tag: string;
    online: OnlineStatus;
    avatar: string;
    roles: DiscordRole[];
}

export interface WorkItem {
    title: string;
    server: string;
    views: string;
    href: string;
    thumbnail: string;
    podium: boolean;
    video: string;
}

export interface GalleryItem {
    immagini: string[];
    cliente: string;
    data: string;
    type: string;
    position: number;
}

export type Client = {
    id: number
    image: string;
    name: string;
    description: string;
    color: string;
    is_highlighted: boolean;
    websiteUrl: string | null;
};

export const urlServer: string = "https://server.enderclub.it/"